<div class="user-detail">
    <div class="table-section  table-responsive table-sticky px-0 pt-0 mt-0" style="max-height: 200px;">
        <table class="table table-default table-user mb-0">
        <thead>
            <tr>
                <th>Document Type</th>
                <th>Name</th>
                <th *ngIf="isDeleteAction" width="56px">Action</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let item of data ;let i = index">
              <td>{{item.docTypeNavigation.displayName}}
                <!-- <span *ngIf="item.docType?.toLowerCase() == Type?.toLowerCase()" matTooltip="{{item.docInfo}}">
                  ({{ item.docInfo?.length > 20 ? item.docInfo?.substring(0, 20) + '...' : item.docInfo }})
                </span> -->
              </td>
              <td class="align-items-center">
                  {{ item.docName }}
                    <button *ngIf="isLogin"
                        class="btn btn-icon-text btn-light-success btn-sm pointer ml-2"
                        matTooltip="Download"
                        (click)="downloadDocument(item,i)">
                        <span class="material-symbols-outlined">download</span>
                    </button>
                </td>

                <td *ngIf="isDeleteAction">
                    <span class="textLink text-danger pointer" (click)="deletePopUp(i,item)"><span class="material-symbols-outlined">
                    delete
                    </span></span></td>
            </tr>
            <tr *ngIf="data?.length === 0">
                <td colspan="3" class="nofoundTxt"><i class="far fa-frown mr-1"></i> No Data Found.</td>
            </tr>
        </tbody>
    </table><br>
</div>
</div>
